import React from 'react'
import { CreateUserForm } from 'components/User/CreateUser'

function Register () {
  return (
    <CreateUserForm />
  )
}

export default Register
